export default {
    // Define your mutations here
    setPhotos(state, payload) {
        state.photos = payload;
    },
}